import { render, staticRenderFns } from "./ModifyKeys.vue?vue&type=template&id=6f851f6b&scoped=true&"
import script from "./ModifyKeys.vue?vue&type=script&lang=js&"
export * from "./ModifyKeys.vue?vue&type=script&lang=js&"
import style0 from "./ModifyKeys.vue?vue&type=style&index=0&id=6f851f6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f851f6b",
  null
  
)

export default component.exports